import { storeWithoutExpiry, getWithoutExpiry } from "@/lib/localStorage";
import ga4 from "@/lib/tracking/ga4Core";

const STORAGE_KEY = "track_edit_listing";
const JOURNEY = "edit_ad";

export const trackStartEditListing = ({ target }) => {
  const eventName = "edit_ad_interaction";

  storeWithoutExpiry(STORAGE_KEY, target);

  const eventParams = {
    target,
    journey_details: JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackEditListingComplete = () => {
  const eventName = "edit_ad_complete";
  const target = getWithoutExpiry(STORAGE_KEY);

  const eventParams = {
    target,
    journey_details: JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
